<!--Copy right - © 2024 tecera gmbh-->
<script>
    import { fade } from "svelte/transition";

    export let water_meter_list;

    export let main_meter;

    $: if (water_meter_list.length == 1) {
        main_meter = water_meter_list[0];
    }
</script>

<div class="input-group" id="compound_role_selection">
    {#if water_meter_list.length != 0}
        <p class="p-modal mt-2" in:fade={{ duration: 400 }}>
            Hauptzähler wählen
        </p>
    {/if}
    {#each water_meter_list as water_meter, idx}
            <div
                class={main_meter == water_meter
                    ? "main_meter col-7  meter-list-element"
                    : "col-7  meter-list-element"}
                in:fade={{ duration: 400 }}
            >
                <strong >{water_meter.sub_id}</strong> - {water_meter.dev_eui}
            </div>
            <div
                class={main_meter == water_meter
                    ? "main_meter col-5  meter-list-element"
                    : "col-5  meter-list-element"}
                in:fade={{ duration: 400 }}
            >
                <label>
                    <input

                        type="radio"
                        bind:group={main_meter}
                        value={water_meter}
                    /> Hauptzähler
                </label>
                <label > 
                    <input
                        type="radio"
                        checked={main_meter == water_meter ? false : true}
                        on:click={() => {
                            if (main_meter == water_meter) {
                                main_meter = null;
                            }
                        }}
                        value={water_meter}
                    /> Nebenzähler
                </label>
            </div>
    {/each}
</div>
